import { render, staticRenderFns } from "./ImportBookmarksWizard.vue?vue&type=template&id=ce94cce2&scoped=true"
import script from "./ImportBookmarksWizard.vue?vue&type=script&lang=js"
export * from "./ImportBookmarksWizard.vue?vue&type=script&lang=js"
import style0 from "./ImportBookmarksWizard.vue?vue&type=style&index=0&id=ce94cce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce94cce2",
  null
  
)

export default component.exports